import React from 'react';
import styles from './index.module.less';
import image from './teachers.png';
const Teachers = () => {
  return (
    <div className={styles.teachers}>
      <div className={styles.title}>一对一辅导老师</div>
      <div className={styles.desc}>大师面对面知道</div>
      <div className={styles.content}>
        <img src={image} alt=""/>
      </div>
    </div>
  );
};

export default Teachers;
